<div class="flex flex-row w-full cursor-pointer">
    <div [class]="columnWidthClasses.controlPoint">
        <p class="content-p">
            {{ controlResult().controlLabel }}
            <span class="pb-3 text-custom-blue">*</span>
        </p>
    </div>

    <div
        class="min-w-0"
        [class]="columnWidthClasses.result">
        @if (controlResult().format === FormatEnum.PHOTO) {
            @if (isLoadingImages()) {
                <div class="w-10">
                    <app-loading
                        [hasMessage]="false"
                        [size]="16"
                        [strokeWidth]="2" />
                </div>
            } @else {
                <app-button
                    [customClass]="'app-btn--picture'"
                    [icon]="['fas', 'image']"
                    [iconPosition]="IconPosition.START"
                    [iconSize]="'sm'"
                    [label]="`(${controlResult().photoCount ?? controlResult().results?.length ?? 0})`"
                    (click)="$event.stopPropagation()"
                    (onClick)="openImageDialog(controlResult())" />
            }
        } @else if (controlResult().format === FormatEnum.DATE) {
            <p class="content-p">
                @if (controlResult().results?.[0]; as result) {
                    {{ result | translocoDate }}
                } @else {
                    -
                }
            </p>
        } @else {
            <p class="content-p">
                {{ controlResult().results?.[0] ?? '-' }}
            </p>
        }
    </div>

    <div [class]="columnWidthClasses.status">
        <app-control-result-slide-toggle
            [controlResult]="controlResult()"
            (validityUpdated)="validityChanged.emit($event)" />
    </div>
</div>
